export default __webpack_public_path__ + "static/media/cash.3b8b8560.svg";